import { render, staticRenderFns } from "./TextCopier.vue?vue&type=template&id=991c4f06"
import script from "./TextCopier.vue?vue&type=script&lang=js"
export * from "./TextCopier.vue?vue&type=script&lang=js"
import style0 from "./TextCopier.vue?vue&type=style&index=0&id=991c4f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports